"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileAsset = void 0;
var create_entity_1 = require("../../utils/create-entity");
var file_asset_value_1 = require("../../components/entities/file-asset-value");
var graphql_1 = require("../../utils/graphql");
exports.FileAsset = {
  name: 'FileAsset',
  label: 'File',
  table: {
    fieldNames: ["info", "createdBy"]
  },
  list: {
    resultsVariant: 'list',
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      id name slug \n      file { \n        id url size type typeName \n        typeImage { id url } \n        formattedSize extension filename \n        thumbnails { \n          id\n          small { id url } \n          large { id url } \n        } \n      }\n    "], ["\n      id name slug \n      file { \n        id url size type typeName \n        typeImage { id url } \n        formattedSize extension filename \n        thumbnails { \n          id\n          small { id url } \n          large { id url } \n        } \n      }\n    "])))
  },
  components: {
    row: file_asset_value_1.FileAssetValue
  },
  canCreateInConversation: true,
  form: {
    fieldSets: [{
      name: 'overview',
      label: 'Overview'
    }, {
      name: 'connections',
      label: 'Connections'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      file: {
        description: 'Choose or link to a file online',
        label: 'File',
        type: 'file',
        required: true
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'FileType',
        description: 'What type of {{FILE_ASSET}} is this?'
      },
      description: {
        type: 'description'
      },
      thumbnail: {
        type: 'image'
      },
      originalSourceUrl: {
        type: 'url',
        label: 'Original Source URL',
        description: "NOTE: For GPT sources only. Leave blank. Uploaded files will use our built-in internal link"
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'connections',
        description: 'Select any {{TRENDS}} which relate to this {{FILE_ASSET}}'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'connections',
        description: 'Select any {{TOPICS}} which relate to this {{FILE_ASSET}}'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'connections',
        description: 'Select any {{SUB_TOPICS}} which relate to this {{FILE_ASSET}}'
      }
    })
  },
  create: {
    label: 'Upload File'
  },
  update: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      file { id url size type typeName formattedSize extension filename thumbnails { id small { id url } large { id url } } }\n      types { id name slug }\n      description { id text }\n      thumbnail { id url thumbnails { id full { id url width height } } }\n    "], ["\n      file { id url size type typeName formattedSize extension filename thumbnails { id small { id url } large { id url } } }\n      types { id name slug }\n      description { id text }\n      thumbnail { id url thumbnails { id full { id url width height } } }\n    "])))
  },
  select: {
    maxWidth: '400px'
  },
  autoRoutes: ['list', 'create', 'update']
};
var templateObject_1, templateObject_2;